/**
 * Navigation Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace navigation
 */

import {register} from '@shopify/theme-sections';
import Headroom from 'headroom.js';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import '../components/search';

export default register('header', {
  onLoad() {
    const self = this;
    this.windowWidth = window.innerWidth;

    this.calculateNavDropdownMaxSize();

    const btnMenuToggle = this.container.querySelector('.nav-toggle');
    btnMenuToggle.addEventListener('click', this.btnMenuClickToggleHandler.bind(this));

    // Closes all dropdowns and nav drawer on browser resize
    window.addEventListener('resize', this.btnMenuClickCloseHandler.bind(this));
    window.addEventListener('resize', this.collapseDropdown.bind(this));

    // Search toggle
    window.searchIsVisible = false;
    // const btnSearch = this.container.querySelector('.header__btn--search');
    // btnSearch.addEventListener('click', this.toggleModal.bind(this));

    const navLinks = this.container.querySelectorAll('.nav__item--toggle');
    navLinks.forEach(function(el) {
      el.addEventListener('click', self.navLinkClickHandler);
    });

    // Drawer tabs for the mobile nav menu
    const $drawerTabs = document.querySelector('.drawer__tabs');
    $drawerTabs.addEventListener('click', this.drawerTabsClickHandler.bind(this));

    // Initialise headroom to hide the top menu in the header when scrolling down the page
    const hideAnnouncementOnScroll = this.container.dataset.hideAnnouncementOnScroll === 'true';
    if (hideAnnouncementOnScroll) {
      document.body.classList.add('hide-announcement-on-scroll');
    }

    const $header = document.querySelector('.site-header');
    const $headerTop = $header.querySelector('.header__top');
    const $headerAnnouncements = $header.querySelector('.header__announcements');
    const $headerMain = $header.querySelector('.header__main');
    const menuNavigation = document.querySelectorAll(".menu-navigation-item");
    const backgroundOverlayMenu = document.querySelectorAll(".background-overlay-menu");
    const calculatorHeight =  $headerTop.offsetHeight + $headerAnnouncements.offsetHeight + $headerMain.offsetHeight
    const headroom = new Headroom($header, {
      offset: $headerTop.offsetHeight,
      onPin: () => {
        $headerAnnouncements.style.top = '0';
        $headerMain.style.top = '0';
        menuNavigation.forEach((item) => {
          item.style.top = `${calculatorHeight}px`;
        });
        backgroundOverlayMenu.forEach((item) => {
          item.style.top = `${calculatorHeight}px`;
        });
      },
      onUnpin: () => {
        const offset = hideAnnouncementOnScroll
          ? $headerTop.offsetHeight + $headerAnnouncements.offsetHeight
          : $headerTop.offsetHeight;
        $headerAnnouncements.style.top = `-${offset}px`;
        $headerMain.style.top = `-${offset}px`;
        menuNavigation.forEach((item) => {
          item.style.top = `${calculatorHeight - offset}px`;
        });
        backgroundOverlayMenu.forEach((item) => {
          item.style.top = `${calculatorHeight - offset}px`;
        });
      },
    });
    headroom.init();

    // Initialise drawer top offset
    const $drawer = this.container.querySelector('.drawer');
    if ($drawer) {
      window.addEventListener('resize', () => {
        this.updateDrawerTopOffset($drawer, $drawerTabs, $headerAnnouncements, $headerMain);
      });
    }
    this.updateDrawerTopOffset($drawer, $drawerTabs, $headerAnnouncements, $headerMain);

    /**
     * Cycle through the announcement by animating them up and down using the [data-active]
     * data attribute by setting to to false/active.
     *
     * Inside the interval we keep looping the index of all the announcements.
     * When the index gets to the end of the array we reset it to 0 and start over.
     */
    const $announcements = this.container.querySelectorAll('[data-announcement]');

    if ($announcements.length > 1) {
      const arrayAnnouncements = Array.from($announcements);
      const announcementsLength = arrayAnnouncements.length;
      let activeAnnouncementIndex = announcementsLength - 1;
      let activeAnnouncement = arrayAnnouncements[activeAnnouncementIndex];

      window.setInterval(() => {
        activeAnnouncement.dataset.active = false;
        activeAnnouncementIndex = activeAnnouncementIndex + 1 >= announcementsLength ? 0 : activeAnnouncementIndex + 1;
        activeAnnouncement = arrayAnnouncements[activeAnnouncementIndex];
        activeAnnouncement.dataset.active = true;
      }, 1000 * 5);
    }

    /**
     * Hide the announcement on click.
     * Set a localstorage value which will hide it on page load.
     */
    const $announcementsClose = this.container.querySelector('[data-announcement-close]');

    if ($announcementsClose) {
      $announcementsClose.addEventListener('click', () => {
        document.body.classList.add('no-announcement');
        $headerAnnouncements.style.display = 'none';

        this.updateDrawerTopOffset($drawer, $drawerTabs, $headerAnnouncements, $headerMain);

        /**
         * Check if we are on a the `product.featured` template, if so recalculate the
         * positioning of the `.product-featured__bar` element
         */
        const $featuredBar = document.querySelector('.product-featured__bar');
        if (!$featuredBar) {
          return;
        }
        $featuredBar.style.top = `${$header.offsetHeight}px`;
      });
    }
  },

  updateDrawerTopOffset(drawer, ...elements) {
    if (!drawer || !elements) return;

    const drawerTopOffset = elements.reduce((total, element) => {
      if (!element) return total;
      return total + element.offsetHeight;
    }, 0);

    drawer.style.top = `${drawerTopOffset}px`;
  },

  calculateNavDropdownMaxSize() {
    let headerSize;
    let navDropdownMaxHeight;
    const header = this.container;
    const navDropdowns = this.container.querySelectorAll('.nav__dropdown');

    window.addEventListener('load', function() {
      headerSize = header.getBoundingClientRect();
      navDropdownMaxHeight = Math.floor(window.innerHeight - headerSize.height);

      navDropdowns.forEach(function(el) {
        if (el && window.innerWidth >= window.theme.breakpoints.widescreen) {
          el.style.cssText = 'max-height: ' + navDropdownMaxHeight + 'px';
        } else {
          el.removeAttribute('style');
        }
      });
    });

    window.addEventListener('resize', function() {
      headerSize = header.getBoundingClientRect();
      navDropdownMaxHeight = Math.floor(window.innerHeight - headerSize.height);

      navDropdowns.forEach(function(el) {
        if (el && window.innerWidth >= window.theme.breakpoints.widescreen) {
          el.style.cssText = 'max-height: ' + navDropdownMaxHeight + 'px';
        } else {
          el.removeAttribute('style');
        }
      });
    });
  },

  /**
   * Click handler for search button
   */
  collapseDropdown() {
    let activeDropdownLinks = this.container.querySelectorAll('.nav__item.nav__item--has-child.is-expanded');
    let navToggles = this.container.querySelectorAll('.nav__item.nav__item--has-child.is-expanded .nav__item--toggle');

    document.body.classList.remove('dropdown-is-active');

    activeDropdownLinks.forEach(function(el) {
      if (el) {
        el.classList.remove('is-expanded');
        el.classList.add('is-collapsed');
      }
    });

    navToggles.forEach(function(el) {
      if (el) {
        el.setAttribute('aria-expanded', false);
      }
    });
  },

  /**
   * .nav-toggle click handler
   */
  btnMenuClickToggleHandler() {
    document.body.classList.toggle('menu-is-expanded');
    document.documentElement.classList.toggle('menu-open');

    const subMenuParents = document.querySelectorAll('.nav__item--has-child');

    subMenuParents.forEach(function(el) {
      if (el.classList.contains('is-expanded')) {
        el.classList.remove('is-expanded');
        el.classList.add('is-collapsed');
      }
    });
  },

  btnMenuClickCloseHandler() {
    // if we are focused in the search field within the nav do nothing
    if (document.activeElement.name === 'query' || window.innerWidth === this.windowWidth) {
      return;
    }

    this.windowWidth = window.innerWidth;

    document.body.classList.remove('menu-is-expanded');

    const subMenuParents = document.querySelectorAll('.nav__item--has-child');
    subMenuParents.forEach(function(el) {
      if (el.classList.contains('is-expanded')) {
        el.classList.remove('is-expanded');
        el.classList.add('is-collapsed');
      }
    });
  },

  /**
   * .nav__item.has-child > a click handler
   */
  navLinkClickHandler(event) {
    const isInMainNav = !!event.currentTarget.closest('.nav--main');
    const isDesktop = window.innerWidth >= window.theme.breakpoints.widescreen;

    // If this link is in the main nav on desktop we can return as dropdowns are triggered on hover
    if (isInMainNav && isDesktop) {
      return;
    }

    event.preventDefault();

    // Menu item toggle
    const navLinks = document.querySelectorAll('.nav__item--toggle');
    const navItem = event.currentTarget.parentElement;
    const thisNavItem = event.currentTarget;

    // Hide the search modal if it's showing
    if (window.searchIsVisible) {
      this.hideModal();
    }

    // event.target.parentElement.classList.toggle('is-expanded');
    if (navItem.classList.contains('is-expanded')) {
      thisNavItem.setAttribute('aria-expanded', false);
      navItem.classList.remove('is-expanded');
      navItem.classList.add('is-collapsed');
      document.body.classList.remove('dropdown-is-active');
    } else {
      navLinks.forEach(el => el.parentElement.classList.remove('is-expanded'));
      navLinks.forEach(el => el.parentElement.classList.add('is-collapsed'));
      navLinks.forEach(el => el.setAttribute('aria-expanded', false));
      navItem.classList.remove('is-collapsed');
      navItem.classList.add('is-expanded');
      document.body.classList.add('dropdown-is-active');
      thisNavItem.setAttribute('aria-expanded', true);
    }

    return true;
  },

  /**
   * Toggles the search modal
   */
  toggleModal() {
    if (window.searchIsVisible) {
      this.hideModal();
    } else {
      this.showModal();
    }
  },

  /**
   * Expands the search modal
   */
  showModal() {
    const searchToggleButton = document.querySelector('.header__btn--search');
    // const searchCloseButton = document.querySelector('.btn--search-close');
    const searchModal = document.querySelector('.search-modal');
    // const searchInput = document.querySelector('.search-input');

    disableBodyScroll(this);
    document.body.classList.add('search-is-visible');
    searchToggleButton.setAttribute('aria-expanded', true);
    // searchCloseButton.setAttribute('aria-expanded', true);
    searchModal.removeAttribute('hidden');

    // if (searchInput) {
    //   searchInput.focus();
    // }
    window.searchIsVisible = true;
    this.collapseDropdown();
  },

  /**
   * Collapses the search modal
   */
  hideModal() {
    const searchToggleButton = document.querySelector('.header__btn--search');
    const searchCloseButton = document.querySelector('.btn--search-close');
    const searchModal = document.querySelector('.search-modal');
    const searchInput = document.querySelector('.search-input');

    enableBodyScroll(this);
    document.body.classList.remove('search-is-visible');
    searchToggleButton.setAttribute('aria-expanded', false);
    searchCloseButton.setAttribute('aria-expanded', false);
    searchModal.addAttribute('hidden', 'hidden');

    if (searchInput) {
      searchInput.blur();
    }
    window.searchIsVisible = false;
  },

  /**
   * Handles clicking the drawer tabs
   */
  drawerTabsClickHandler(event) {
    const $tab = event.target.closest('.drawer__tab');
    if (!$tab) {
      return;
    }
    const $tabContent = document.querySelector(`#${$tab.getAttribute('aria-controls')}`);
    if (!$tabContent) {
      return;
    }
    const $allTabs = document.querySelectorAll('.drawer__tab');
    const $allTabContents = document.querySelectorAll('.drawer__tab-content');

    $allTabs.forEach($tab => {
      $tab.classList.remove('active');
      $tab.removeAttribute('aria-selected');
    });
    $allTabContents.forEach($tabPanel => $tabPanel.classList.remove('active'));

    $tab.classList.add('active');
    $tab.setAttribute('aria-selected', 'true');
    $tabContent.classList.add('active');

    const $announcement = this.container.querySelector('.announcement');
    if ($announcement) {
      if ($tab.classList.contains('drawer__tab--tangerine')) {
        $announcement.classList.add('announcement--tangerine');
        $announcement.classList.remove('announcement--green');
      } else {
        $announcement.classList.remove('announcement--tangerine');
        $announcement.classList.add('announcement--green');
      }
    }
  },
});
